var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._g(_vm._b({},'v-container',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.langs),function(langPim,lang){return [_c('flag',{key:langPim,class:_vm.getClasses(_vm.value, langPim),staticStyle:{"margin-right":"5px"},attrs:{"iso":lang}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }